
<template>
    <div>
        <topback title="Payment Method(s)" path="back"></topback>
        <div class="paymentmethods">
            <div class="noassets" v-if="list.length === 0">
                <md-result-page class="customized" img-url="/static/icon/kyc.png" text="no payment method"
                    subtext="">
                </md-result-page>
            </div>
    
            <md-bill v-for="bank in list" v-bind:key="bank.id" v-if="bank.method === 'bank'">
                <template slot="header">
                    <pointtext class="paymentmethod-type" type="line-purple" text="Bank Transfer"></pointtext>
                    <div class="md-bill-no" @click="go_edit(bank.id)">
                        <iconimg name="edit" size="lg"></iconimg>
                    </div>
                </template>
                <md-detail-item title="Name">
                    {{ bank.name }}
                </md-detail-item>
                <md-detail-item title="Account">
                    {{ bank.account }}
                </md-detail-item>
                <md-detail-item title="Bank Name" content="India Bank" />
                <md-detail-item title="IFSC">
                    {{ bank.bank_name }}
                </md-detail-item>
            </md-bill>
            <md-bill v-else>
                <template slot="header">
                    <pointtext class="paymentmethod-type" type="line-success" text="UPI"></pointtext>
                    <div class="md-bill-no" @click="go_edit(bank.id)">
                        <iconimg name="edit" size="lg"></iconimg>
                    </div>
                </template>
                <md-detail-item title="Name">
                    {{ bank.name }}
                </md-detail-item>
                <md-detail-item title="UPI" :content="bank.upi" />
            </md-bill>
        </div>

        <md-button type="primary" @click="go_addpaymentmethod">Add a payment method</md-button>
    </div>
</template>

<script>
import topback from '@/components/topback'
import iconimg from '@/components/iconimg'
import pointtext from '@/components/pointtext'
import { getpayments, postpayment } from '@/request/api'


export default {
    name: 'paymentmethods',
    components: {
		[topback.name]: topback,
        [iconimg.name]: iconimg,
        [pointtext.name]: pointtext
    },

    data() {
        return {
            list: []
        }
    },
    created() {
        this.getpaymenthodlist();
    },
    methods: {
        getpaymenthodlist() {
            getpayments().then(res=>{
                if(res.code === 200) {
                    this.list = res.data;
                } else {
                    this.$toast.failed(res.errmsg);
                }
            })
        },
        go_addpaymentmethod() {
            this.$router.push('/addpaymentmethod')
        },
        go_edit(id) {
            this.$router.push('/editpaymentmethod/' + id);
        }
    }

}

</script>

<style scoped>
.paymentmethods {
    margin-top: 0.8rem;
}
.paymentmethod-type {
    font-size: 0.36rem;
}
.paymentmethod-type >>> span {
    color: black !important;
    font-weight: 400;
}
.noassets {
    margin-top: 1.5rem;
    margin-bottom: 0.2rem;
}

.noassets>>>.md-result-image {
    width: 1.6rem;
}

.noassets>>>.md-result-text {
    margin: 0;
    color: #01080f;
    font-size: 0.12rem;
}

.noassets>>>.md-result-subtext {
    margin-top: 0.16rem;
    color: red;
    font-size: 0.28rem;
}
</style>



// WEBPACK FOOTER //
// src/views/my/paymentmethods.vue